import React, { useState } from "react";

const PopUp = ({ handleFilterApply }) => {
  const [filters, setFilters] = useState({
    day: true,
    vol: true,
    bfat: true,
    prt: true,
    scc: true,
    bac: true,
    bse: true,
    fpd: true,
    ant: true,
    urea: true,
    syn: true,
    bcfu: true,
    sbcfu: true,
  });
  const [popupStyle, setPopupStyle] = useState({
    visibility: "visible",
    opacity: 1,
  });
  const handleApplyFilter = () => {
    handleFilterApply(filters);
    setPopupStyle({
      visibility: "hidden",
      opacity: 0,
    });
  };
  const handleCheckboxChange = (filter) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filter]: !prevFilters[filter],
    }));
  };

  return (
    <div className="overlay parent_popup" id="popup1 "style={popupStyle}>
      <div
        className="popup"
        style={{
          display: "block",
        }}
      >
        <p>Select which options to display</p>

        <a className="close">
          <i className="fas fa-times" />
        </a>

        <div className="popupcontent custom_popupcontent">
          <ul>
            {Object.keys(filters).map((filter) => (
              <li key={filter}>
                <div className="checkbox">
                  <label className="checkcontainer">
                    <input
                      defaultChecked={filters[filter]}
                      onChange={() => handleCheckboxChange(filter)}
                      id={`chk-${filter}`}
                      type="checkbox"
                    />
                    <span className="cr">
                      <i className="cr-icon fas fa-check" />
                    </span>
                    {filter.toUpperCase()}
                  </label>
                </div>
              </li>
            ))}
          </ul>

          <div className="apply-filter_ct" id="apply-filter">
            <a onClick={handleApplyFilter}>
              <i className="icon-rg fas fa-check" />

              <span>APPLY FILTER</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopUp;
